import { render, staticRenderFns } from "./pubheader.vue?vue&type=template&id=277d9592&scoped=true"
import script from "./pubheader.vue?vue&type=script&lang=js"
export * from "./pubheader.vue?vue&type=script&lang=js"
import style0 from "./pubheader.vue?vue&type=style&index=0&id=277d9592&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277d9592",
  null
  
)

export default component.exports